// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"a8b1afd3","179":"aee5bc2b","239":"bff0b062","250":"6db9b9c0","437":"6bf662c2","671":"8c9745b6"}[chunkId] + ".chunk.js";
};